import { render } from "./ThreeDBox.vue?vue&type=template&id=7cf6fdd4&scoped=true"
import script from "./ThreeDBox.vue?vue&type=script&lang=js"
export * from "./ThreeDBox.vue?vue&type=script&lang=js"

import "./ThreeDBox.vue?vue&type=style&index=0&id=7cf6fdd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf6fdd4"]])

export default __exports__